<template>
  <div class="wanfa-cont">
    <p>1、最佳悬赏红包怎么玩？</p>
    <p>最佳悬赏问答会从所有回答者中选出“最佳回答”，对应回答者将能获得该问题的全部红包，具体流程如下：</p>
    <p>1) 悬赏问答发出后，所有人均可通过回答参与互动</p>
    <p>2) 提问者将在收到回答后，开始评选出“最佳回答”</p>
    <p>3) 答案被评选为“最佳回答”的参与者，将领取到对应奖励红包</p>
    <p>ps：</p>
    <p>若提问者超过14个工作日未评选出最佳回答，系统将直接评选；</p>
    <p>若提问者超过30个工作日未收到任何回答，系统将退回悬赏。</p>
    <br>
    <p>2、怎么领取最佳悬赏红包？</p>
    <p>当你的答案被评为“最佳回答”，系统将会通过站内通知、短信、邮件等形式通知到你，此时你可进入对应问题详情页领取悬赏，领取后现金将转入你的钱包中，可自行前往提现。</p>
    <p>若进入问题详情页后没找到红包领取按钮，可确认是否已领取过，或者是登录的账号是否正确。</p>
    <br>
    <p>3、如何发布最佳悬赏问答？</p>
    <p>通过登录人人动画网，进入问答，发布提问时选择“悬赏”方案即可</p>
    <br>
    <p>4、违规操作会受到什么处罚？</p>
    <p>以下操作均属于违规操作：</p>
    <p>1) 恶意提交与问题无关的回答；</p>
    <p>2) 提交违规答案，如营销广告、人身攻击、色情、涉及政治及侵犯他人合法权益的内容等；</p>
    <br>
    <p>所有违规操作将会视情节严重程度，进行内容删除、拉黑、禁止提现等。</p>
    <!-- <div class="ask-user">上述内容是否对您有用？</div> -->
    <div class="articled-zan-cai">
      <div class="item" :class="{ active:locLikeFlag }" v-on:click="likeEvent(999,null)">
        <i class="icon zan" ></i>
        <span>{{locLikeCount}}</span>
      </div>
      <div class="item" :class="{ active: locDisLikeFlag }" v-on:click="disLikeEvent(999,null)">
        <i class="icon cai"></i>
        <span>{{locDisLikeCount}}</span>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import apiService from '@/api/index';
import global_ from '@/api/global';

export default {
  // props: ['likeFlag','disLikeFlag','likeCount','disLikeCount'],
  props:{
    likeCount: {
      type: Number
    },
    disLikeCount: {
      type: Number
    },
    likeFlag:{
      type:Boolean
    },
    disLikeFlag:{
      type:Boolean
    }
  },
  data () {
    return {
      locLikeCount:0,
      locDisLikeCount:0,
      locLikeFlag:false,
      locDisLikeFlag:false,
    }
  },
  mounted () {
    setTimeout(()=>{
      console.log('this.dislikeCount',this.disLikeCount)
      console.log('this.likeCount',this.likeCount)
      this.locDisLikeCount = this.disLikeCount
      this.locLikeCount = this.likeCount
      this.locDisLikeFlag = this.disLikeFlag
      this.locLikeFlag = this.likeFlag
    },200)

  },
  methods: {

    likeEvent(id,belongSection){
      let _this =this;
      if(_this.global.isLogin){
        apiService.dolike({"objectType":11,"objectId":id,"belongSection":belongSection,"time": new Date().getMilliseconds()}).then(data => {
          if(_this.locLikeFlag){
            _this.locLikeCount=_this.locLikeCount-1;
            _this.locLikeFlag=false;
          }else{
            _this.locLikeCount=_this.locLikeCount+1;
            _this.locLikeFlag=true;
          }
        })
      }else{
        _this.$message.error('您尚未登录,请登录后操作')
        return false
      }
    },
    disLikeEvent(id,belongSection){
      var _this =this;
      if(this.global.isLogin) {
        apiService.dislike({"objectType":11, "objectId": id,"belongSection":belongSection,"time": new Date().getMilliseconds()}).then(data => {
          if(_this.locDisLikeFlag){
            _this.locDisLikeCount=_this.locDisLikeCount-1;
            _this.locDisLikeFlag=false;
          }else{
            _this.locDisLikeCount=_this.locDisLikeCount+1;
            _this.locDisLikeFlag=true;
          }
        })
      }else{
        _this.$message.error('您尚未登录,请登录后操作')
        return false
      }
    }
  }
}
</script>

<style scoped lang="less">

</style>
